import { MainLayout } from "@/components/layout/MainLayout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { DollarSign, ArrowDownRight, Wallet, Building2, Tag, Users, Receipt, Brain, FileText } from "lucide-react";
import { FaturasTab } from "@/components/financiero/FaturasTab";
import { CmvTab } from "@/components/financiero/CmvTab";
import { IAFinanceiraTab } from "@/components/financiero/IAFinanceiraTab";
import { MovimientosTab } from "@/components/financiero/MovimientosTab";
import { CaixasTab } from "@/components/financiero/CaixasTab";
import { ContasTab } from "@/components/financiero/ContasTab";
import { ProveedoresTab } from "@/components/financiero/ProveedoresTab";
import { CategoriasTab } from "@/components/financiero/CategoriasTab";
import { PagoOnlineTab } from "@/components/financiero/PagoOnlineTab";
import { AccountingReportsTab } from "@/components/financiero/AccountingReportsTab";

export default function FinancieroPage() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl sm:text-4xl font-bold uppercase tracking-tight">Gestão Financeira</h1>
          <p className="text-muted-foreground mt-1">Faturas, custos, CMV e controle financeiro do restaurante</p>
        </div>
        <Tabs defaultValue="faturas">
          <TabsList className="bg-secondary flex-wrap h-auto gap-1 p-1">
            <TabsTrigger value="faturas" className="gap-1.5" data-testid="tab-faturas"><Receipt className="w-3.5 h-3.5" />Faturas</TabsTrigger>
            <TabsTrigger value="cmv" className="gap-1.5" data-testid="tab-cmv"><ArrowDownRight className="w-3.5 h-3.5" />CMV / DRE</TabsTrigger>
            <TabsTrigger value="ia-financeira" className="gap-1.5" data-testid="tab-ia-financeira"><Brain className="w-3.5 h-3.5" />IA Financeira</TabsTrigger>
            <TabsTrigger value="movimientos" className="gap-1.5"><Receipt className="w-3.5 h-3.5" />Movimientos</TabsTrigger>
            <TabsTrigger value="caixas" className="gap-1.5"><DollarSign className="w-3.5 h-3.5" />Caixas</TabsTrigger>
            <TabsTrigger value="contas" className="gap-1.5"><Building2 className="w-3.5 h-3.5" />Contas</TabsTrigger>
            <TabsTrigger value="proveedores" className="gap-1.5"><Users className="w-3.5 h-3.5" />Proveedores</TabsTrigger>
            <TabsTrigger value="categorias" className="gap-1.5"><Tag className="w-3.5 h-3.5" />Categorías</TabsTrigger>
            <TabsTrigger value="pago-online" className="gap-1.5"><Wallet className="w-3.5 h-3.5" />Pago Online</TabsTrigger>
            <TabsTrigger value="informes-contabilidad" className="gap-1.5"><FileText className="w-3.5 h-3.5" />Informes Contabilidad</TabsTrigger>
          </TabsList>
          <TabsContent value="faturas" className="mt-6"><FaturasTab /></TabsContent>
          <TabsContent value="cmv" className="mt-6"><CmvTab /></TabsContent>
          <TabsContent value="ia-financeira" className="mt-6"><IAFinanceiraTab /></TabsContent>
          <TabsContent value="movimientos" className="mt-6"><MovimientosTab /></TabsContent>
          <TabsContent value="caixas" className="mt-6"><CaixasTab /></TabsContent>
          <TabsContent value="contas" className="mt-6"><ContasTab /></TabsContent>
          <TabsContent value="proveedores" className="mt-6"><ProveedoresTab /></TabsContent>
          <TabsContent value="categorias" className="mt-6"><CategoriasTab /></TabsContent>
          <TabsContent value="pago-online" className="mt-6"><PagoOnlineTab /></TabsContent>
          <TabsContent value="informes-contabilidad" className="mt-6"><AccountingReportsTab /></TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
